import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from "react-redux";
import styles from "./CollabsView.module.css";
import Langs, { Localize } from "../../app/lang/langs";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import userInfo from "../../assets/images/userInfo.png";
import userInfoFocus from "../../assets/images/userInfoFocus.png";
import userPlanning from "../../assets/images/planning.png";
import userPlanningFocus from "../../assets/images/planningFocus.png";
import fusion from "../../assets/images/fusion.png";
import fusionFocus from "../../assets/images/fusionFocus.png";
import ImageButton from "../../components/buttons/ImageButton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  capitalize,
  checkPermission,
  getFormattedDate,
  getTagClass
} from "../../app/utils/helpers";
import moment from "moment";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Tag } from "primereact/tag";
import CollabModalDetails from "./CollabModalDetails";
import ResetPasswordDialog from './ResetPasswordDialog';
import PermissionsModal from "./PermissionsModal";
import { showSuccessToast, showErrorToast } from "../../app/utils/helpers";
import { ViewSelectButton } from "../../components/buttons/ViewSelectButton";
import WarningDetailsDialog from "../warnings/dialogs/WarningDetails";
import deleteIcon from "../../assets/images/delete.png";
import deleteIconFocus from "../../assets/images/delete-orange.png";
import { config } from "../../app/utils/config";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import handicapIcon from "../../assets/images/handicap.png";
import AddWarning from "../warnings/dialogs/AddWarning";
import { Dialog } from "primereact/dialog";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllCollabs,
  setCollabModalData,
  setUpdatePermissionsRes,
  getAllWarnings,
  setSelectedView,
  setAddWarningRes,
  setWarningData,
  setWarningDetailsDialog,
  deleteWarning,
  setWarningDeleteRes,
  setWarningEditRes,
  setAddWarningDialog,
  getSpecialCases,
  setSpecialCaseModalData,
  setDisplaySpecialCaseModalDetails,
  typeOfContractOptions,
  getAllContracts
} from "../../components/collabs/collabsSlice";
import AddExterneModal from "./AddExterneModal";
import { getSubcontractors } from "../../components/clients/clientsSlice";
import AddSpecialCaseModal from "./AddSpecialCaseModal";
import SpecialCaseDetailsDialog from "./SpecialCaseDetails";
import { Calendar } from "primereact/calendar";
import { getAllTeamsManagers, setSelectedTeams } from "../../components/teams/teamsSlice";
import MergeCollabModal from "./MergeCollabModal";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import EmploymentPromisesView from "./EmploymentPromisesView";
import { MultiSelect } from "primereact/multiselect";
import ExcelManager from "../../app/managers/excelManager";
import { setIsLoading } from "../common/commonSlice";

export function CollabsView() {

  const dispatch = useDispatch()
  const urlParams = useParams()
  const navigate = useNavigate()
  const mounted = useRef(null)
  const dtCollabs = useRef(null)
  const dtWarnings = useRef(null)
  const dtSpecialCases = useRef(null)

  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
  const permissionsMessage = useSelector((state) => state.collabs.updatePermissionsRes)
  const allCollabsList = useSelector((state) => state.collabs.allCollabsList)
  const allWarningsList = useSelector((state) => state.collabs.warningsList)
  const deleteWarningRes = useSelector((state) => state.collabs.warningDeleteRes)
  const editWarningsRes = useSelector((state) => state.collabs.warningEditRes)
  const addWarningRes = useSelector((state) => state.collabs.addWarningRes)
  const selectedView = useSelector((state) => state.collabs.selectedView)
  const permissions = useSelector((state) => state.login.permissions)
  const [deleteWarningId, setDeleteWarningId] = useState(null)
  const isMobile = useSelector((state) => state.settings.isMobile)
  const specialCases = useSelector((state) => state.collabs.specialCases)
  const allContractsList = useSelector((state) => state.collabs.allContracts)

  const [displayAddExterneModal, setDisplayAddExterneModal] = useState(false)
  const [displaySpecialCaseModal, setDisplaySpecialCaseModal] = useState(false)
  const [showNewOnly, setShowNewOnly] = useState(false)
  const [collabsGlobalFilterValue, setCollabsGlobalFilterValue] = useState('')
  const [warningsGlobalFilterValue, setWarningsGlobalFilterValue] = useState('')
  const [specialCasesGlobalFilterValue, setSpecialCasesGlobalFilterValue] = useState('')
  const [filteredCollabs, setFilteredCollabs] = useState(null)

  const [collabsFilters, setCollabsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    matricule: { value: null, matchMode: FilterMatchMode.CONTAINS },
    current_poste: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nature_emploi: { value: null, matchMode: FilterMatchMode.CONTAINS },
    statut_emploi: { value: null, matchMode: FilterMatchMode.CONTAINS },
    coefficient: { value: null, matchMode: FilterMatchMode.CONTAINS },
    position: { value: null, matchMode: FilterMatchMode.CONTAINS },
    etablissement: { value: null, matchMode: FilterMatchMode.CONTAINS },
    security_number: { value: null, matchMode: FilterMatchMode.CONTAINS },
    current_team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    last_team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    mobileNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type_collab: { value: null, matchMode: FilterMatchMode.EQUALS },
    motif_sortie: { value: null, matchMode: FilterMatchMode.IN },
    statut: { value: null, matchMode: FilterMatchMode.EQUALS },
    company: { value: null, matchMode: FilterMatchMode.EQUALS },
    first_experience_date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    primary_date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    ancienneteeDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    entryDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    periodeEssai1: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    periodeEssai2: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    exitDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    last_contract_sortie_date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    type_contrat: { value: null, matchMode: FilterMatchMode.IN },
    silaeStatus: { value: null, matchMode: FilterMatchMode.IN },
    new_date_fin_cp: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    date_debut_cp: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    date_fin_cp: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
  })

  const [warningsFilters, setWarningsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    collab_matricule: { value: null, matchMode: FilterMatchMode.CONTAINS },
    team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    collab_nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    collab_prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    category: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    warning_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    created_at: { value: null, matchMode: FilterMatchMode.DATE_IS },
    updated_at: { value: null, matchMode: FilterMatchMode.DATE_IS }
  })

  const [specialCasesFilters, setSpecialCasesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom_collab: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom_collab: { value: null, matchMode: FilterMatchMode.CONTAINS },
    case: { value: null, matchMode: FilterMatchMode.EQUALS },
    startDate: { value: null, matchMode: FilterMatchMode.DATE_IS },
    endDate: { value: null, matchMode: FilterMatchMode.DATE_IS }
  })

  let newCollabsList = allCollabsList.filter(c => c.is_new)
  function listCollabs() {
    if (showNewOnly) {
      return newCollabsList
    }
    return allCollabsList
  }

  const onCollabsGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...collabsFilters };

    _filters['global'].value = value;

    setCollabsFilters(_filters);
    setCollabsGlobalFilterValue(value);
  }

  const onWarningsGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...warningsFilters };

    _filters['global'].value = value;

    setWarningsFilters(_filters);
    setWarningsGlobalFilterValue(value);
  }

  const onSpecialCasesGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...specialCasesFilters };

    _filters['global'].value = value;

    setSpecialCasesFilters(_filters);
    setSpecialCasesGlobalFilterValue(value);
  }

  const collabsTableHeader = () => {
    return (<Row>
      <Col md={6}>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={collabsGlobalFilterValue} onChange={onCollabsGlobalFilterChange} placeholder="Keyword Search" />
        </IconField>
      </Col>
      {newCollabsList.length != 0 &&
        <Col md={6} className="d-flex justify-content-end align-items-center mt-2">
          <label><Langs str="Show new collabs only" /></label>
          <InputSwitch className="ms-2 me-2"
            onChange={(e) => setShowNewOnly(e.value)} checked={showNewOnly} />
        </Col>}
    </Row>
    )
  }

  const warningsTableHeader = () => {
    return (
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText value={warningsGlobalFilterValue} onChange={onWarningsGlobalFilterChange} placeholder="Keyword Search" />
      </IconField>
    )
  }

  const specialCasesTableHeader = () => {
    return (
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText value={specialCasesGlobalFilterValue} onChange={onSpecialCasesGlobalFilterChange} placeholder="Keyword Search" />
      </IconField>
    );
  };

  const [viewsOptions] = useState([
    { label: <Langs str='Collabs' />, value: 0 },
    { label: <Langs str='Suivis' />, value: 1 },
    { label: <Langs str='SPECIAL_CASES' />, value: 2 },
    { label: <Langs str='EMPLOYMENT_PROMISES' />, value: 3 }
  ])

  const [mergeCollab, setMergeCollab] = useState(null)

  const [confirmDeleteVisibility, setConfirmDeleteVisibility] = useState(false)

  useEffect(() => {
    if (checkPermission(config.scopes.collabs, config.permissionTypes.view)) {
      dispatch(setSelectedView(0))
    } else if (checkPermission(config.scopes.warnings, config.permissionTypes.view) && !checkPermission(config.scopes.collabs, config.permissionTypes.view)) {
      dispatch(setSelectedView(1))
    }
  }, [mounted, permissions])

  useEffect(() => {
    if (urlParams.subView && viewsOptions[urlParams.subView]) {
      dispatch(setSelectedView(urlParams.subView))
    }
  }, [urlParams])

  useEffect(() => {
    if (!mounted.current) {
      dispatch(getSubcontractors())
      dispatch(getSpecialCases())
      if (checkPermission(config.scopes.collabs, config.permissionTypes.view)) {
        dispatch(getAllCollabs())
        dispatch(getAllContracts())
      }
      if (checkPermission(config.scopes.warnings, config.permissionTypes.view)) {
        dispatch(getAllWarnings())
      }
      mounted.current = true
    }
  }, [dispatch])

  useEffect(() => {
    toastRes()
  }, [permissionsMessage])

  useEffect(() => {
    if (deleteWarningRes != null) {
      if (deleteWarningRes.trim().toLowerCase().includes("successfully")) {
        showSuccessToast(deleteWarningRes)
      } else {
        showErrorToast(deleteWarningRes)
      }
      dispatch(setWarningDeleteRes(null))
    }
  }, [deleteWarningRes])

  useEffect(() => {
    if (editWarningsRes != null) {
      if (editWarningsRes.trim().toLowerCase().includes("successfully")) {
        showSuccessToast(editWarningsRes)
      } else {
        showErrorToast(editWarningsRes)
      }
      dispatch(setWarningEditRes(null))
    }
  }, [editWarningsRes])

  useEffect(() => {
    if (addWarningRes != null) {
      if (addWarningRes.trim().toLowerCase().includes("successfully")) {
        showSuccessToast(<Langs str="WARNING_SUCCESS" />)
      } else {
        showErrorToast(<Langs str="DUPICATE_WARNING" />)
      }
      dispatch(setAddWarningRes(null))
    }
  }, [addWarningRes])

  const exportExcelCollabs = (allManagers) => {

    let filteredData = filteredCollabs || allCollabsList

    let exportData = filteredData.reduce((array, current) => {
      let teamManagers = allManagers[current.current_id_team]
      let dms = []
      let rcs = []
      if (teamManagers) {
        teamManagers.map(tm => {
          if (tm.type == "RESPCOMPTE") {
            rcs.push(`${tm.prenom} ${tm.nom}`)
          } else {
            dms.push(`${tm.prenom} ${tm.nom}`)
          }
        })
      }
      let collabData = {
        "Matricule": current.matricule || "",
        "Entreprise": current.company || "",
        "Type de collaborateur": current.type_collab || "",
        "Civilité": current.title || "",
        "Nom de famille": current.nom || "",
        "Prénom": current.prenom || "",
        "Statut": current.statut || "",
        "Statut Silae": Localize(current.silaeStatus) || "",
        "Équipe actuelle": current.current_team_name || "",
        "Dernière équipe": current.last_team_name || "",
        "Téléphone": current.mobileNumber || "",
        "Type de contrat": current.type_contrat || "",
        "Email": current.email || "",
        "Numéro de sécurité sociale": current.security_number || "",
        "Poste actuel": current.current_poste || "",
        "Nature emploi": current.nature_emploi || "",
        "Statut emploi": current.statut_emploi || "",
        "Coefficient": current.coefficient || "",
        "Position": current.position || "",
        "Date de première expérience": current.first_experience_date ? moment(current.first_experience_date).format("DD-MM-YYYY") : "",
        "Date d’ancienneté": current.ancienneteeDate ? moment(current.ancienneteeDate).format("DD-MM-YYYY") : "",
        "Date d'entrée": current.entryDate ? moment(current.entryDate).format("DD-MM-YYYY") : "",
        "Période d’essai 1": current.periodeEssai1 ? moment(current.periodeEssai1).format("DD-MM-YYYY") : "",
        "Période d’essai 2": current.periodeEssai2 ? moment(current.periodeEssai2).format("DD-MM-YYYY") : "",
        "Date de fin titre de sejour": current.date_fin_titre_sejour ? moment(current.date_fin_titre_sejour).format("DD-MM-YYYY") : "",
        "Date de sortie": current.exitDate ? moment(current.exitDate).format("DD-MM-YYYY") : "",
        "Date de sortie effective": current.last_contract_sortie_date ? moment(current.last_contract_sortie_date).format("DD-MM-YYYY") : "",
        "Motif de sortie": current.motif_sortie || "",
        "Commentaires": current.comments || "",
        "CPN-1 (restant dans Silae)": current.solde_cp_old_remaining || "",
        "CPN (restant dans Silae)": current.solde_cp_current_remaining || "",
        "CPN-1": current.solde_cp_old || "",
        "Date d’expiration CPN-1": current.solde_cp_old_expiry ? moment(current.solde_cp_old_expiry).format("DD-MM-YYYY") : "",
        "CPN": current.solde_cp_current || "",
        "Frais téléphone": current.frais_tel || "",
        "Forfait déplacement": current.forfait_deplacement || "",
        "Date début CP": current.date_debut_cp ? moment(current.date_debut_cp).format("DD-MM-YYYY") : "",
        "Date fin CP": current.date_fin_cp ? moment(current.date_fin_cp).format("DD-MM-YYYY") : "",
        "Nouvelle date fin CP": current.new_date_fin_cp ? moment(current.new_date_fin_cp).format("DD-MM-YYYY") : "",
        "TJM achat": current.tjm_achat || "",
        "TJM vente": current.tjm_vente || "",
        "Sous-traitant": current.subcontractor || "",
        "Email sous-traitant": current.subcontractor_email || "",
        "Date de création": current.createdAt ? moment(current.createdAt).format("DD-MM-YYYY") : "",
        "Prime de mission": current.prime_mission ?? "",
        "Managers": dms.join(", "),
        "Resp Compte": rcs.join(", ")
      }

      array.push(collabData)
      return array
    }, [])

    ExcelManager.getInstance().generateAndDownloadExcelFromData(exportData, "collaborateurs")

  }

  const exportExcelContracts = () => {
    let exportDataContract = allContractsList.reduce((array, current) => {
      let contractData = {
        "Prénom": current.prenom || "",
        "Nom de famille": current.nom || "",
        "ID": current.id || "",
        "ID Collaborateur": current.id_collab || "",
        "ID Entreprise": current.id_company || "",
        "ID Sous-traitant": current.id_subcontractor || "",
        "Type de contrat": current.type_contrat || "",
        "Type de collaborateur": current.type_collab || "",
        "Statut emploi": current.statut_emploi || "",
        "Date d'entrée": current.entree_date ? moment(current.entree_date).format("DD-MM-YYYY") : "",
        "Date de sortie": current.sortie_date ? moment(current.sortie_date).format("DD-MM-YYYY") : "",
        "Poste": current.position || "",
        "Coefficient": current.coefficient || "",
        "Code CSP": current.code_csp || "",
        "Période d’essai 1": current.periode_essai_1 ? moment(current.periode_essai_1).format("DD-MM-YYYY") : "",
        "Période d’essai 2": current.periode_essai_2 ? moment(current.periode_essai_2).format("DD-MM-YYYY") : "",
        "Mise sous pli": current.mise_sous_pli || "",
        "Dédit formation": current.dedit_formation || "",
        "Motif de sortie": current.motif_sortie || "",
        "Durée période d’essai 1": current.duree_periode_essai_1 || "",
        "Durée période d’essai 2": current.duree_periode_essai_2 || "",
        "Date rappel 1": current.date_rappel_1 ? moment(current.date_rappel_1).format("DD-MM-YYYY") : "",
        "Date rappel 2": current.date_rappel_2 ? moment(current.date_rappel_2).format("DD-MM-YYYY") : "",
        "N’a pas démarré": current.did_not_start || "",
        "TJM achat": current.tjm_achat || "",
        "TJM vente": current.tjm_vente || "",
        "Date début CP": current.date_debut_cp ? moment(current.date_debut_cp).format("DD-MM-YYYY") : "",
        "Date fin CP": current.date_fin_cp ? moment(current.date_fin_cp).format("DD-MM-YYYY") : "",
        "Nouvelle date début CP": current.new_date_debut_cp ? moment(current.new_date_debut_cp).format("DD-MM-YYYY") : "",
        "Nouvelle date fin CP": current.new_date_fin_cp ? moment(current.new_date_fin_cp).format("DD-MM-YYYY") : "",
        "Date d’envoi": current.sent_date ? moment(current.sent_date).format("DD-MM-YYYY") : "",
        "Mutuelle": current.mutuelle || "",
        "Ticket restaurant": current.ticket_restaurant || "",
        "Pass Navigo": current.pass_navigo || "",
        "Taux horaire": current.taux_horaire || "",
        "Établissement": current.etablissement || "",
        "Nature emploi": current.nature_emploi || "",
        "Renouvellement période d’essai": current.renew_periode_essai || "",
        "Responsable contractuel": current.responsable_contractuel || "",
        "Statut Silae": current.silae_status || "",
        "Date de création": current.created_at ? moment(current.created_at).format("DD-MM-YYYY") : "",
        "Date de mise à jour": current.updated_at ? moment(current.updated_at).format("DD-MM-YYYY") : "",
        "Créé par": current.created_by || "",
        "Mis à jour par": current.updated_by || "",
        "Nom sous-traitant": current.subcontractor_name || "",
        "Tuteur": current.tutor_name || "",
        "Ecole": current.school || "",
        "Contact école": current.school_contact || "",
        "Diplome": current.diploma || "",
        "Coût de la formation": current.training_cost || "",
        "Reste à charge": current.remaining_cost || "",
        "Commentaires": current.comments || "",
      }

      array.push(contractData);
      return array;
    }, []);
    console.log(exportDataContract)
    ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataContract, "contrats_collaborateurs");
  };


  const exportFilteredData = () => {
    let subView = viewsOptions[selectedView]
    switch (subView.value) {
      case 0:
        dispatch(setIsLoading(true))
        dispatch(getAllTeamsManagers()).unwrap().then((response) => {
          exportExcelCollabs(response?.responseData?.managers)
          dispatch(setIsLoading(false))
        }).catch((error) => {
          dispatch(setIsLoading(false))
        })
        break
      case 1:
        dtWarnings.current.exportCSV(true)
        break
      case 2:
        dtSpecialCases.current.exportCSV(true)
        break
      default:
        break
    }
  }

  const statusBodyTemplate = (rowData) => {
    if (rowData.is_new) {
      return <Tag value={<Langs str="New" />} severity={getTagClass("New")} />
    }
    return <div style={{ color: (["Présent", "Actif"].includes(rowData.statut) ? "green" : "red") }}>
      <strong>{rowData.statut}</strong>
    </div>
  }

  const soldeExpirylBodyTemplate = (rowData) => {
    return (<label className="text-center text-danger">
      {rowData.solde_cp_old_expiry ? getFormattedDate(rowData.solde_cp_old_expiry) : '-'}
    </label>)
  }

  const soldeCurrentBodyTemplate = (rowData) => {
    return <label>
      <strong>
        {rowData.solde_cp_current}
      </strong>
    </label>
  }

  const soldeOldBodyTemplate = (rowData) => {
    return <label>
      <strong>
        {rowData.solde_cp_old}
      </strong>
    </label>
  }

  const formatDate = (value) => {
    if (value)
      return value.toLocaleDateString({
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    else return null
  }

  const dateBodyTemplate = (rowData, column) => {
    if (rowData[column.field]) {
      return <label>
        {formatDate(rowData[column.field])}
      </label>
    }
  }

  /**
 * 
 * @param {*} rowData 
 * @param {*} column 
 * @param {*} withColors 
 * @returns 
 */
  const colorDateBodyTemplate = (rowData, column) => {
    let textClassName = ""
    if (rowData[column.field]) {
      if (moment(rowData[column.field]).isAfter(moment())) {
        textClassName = "text-success"
      } else if (moment(rowData[column.field]).isBefore(moment())) {
        textClassName = "text-danger"
      }
      return <label className={`${textClassName}`}>
        {formatDate(rowData[column.field])}
      </label>
    }
  }

  const createdAtDateBodyTemplate = (rowData) => {
    const formatDate = (timestamp) => {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      date.setHours(date.getHours() + 2);
      const isoString = date.toISOString().substring(0, 16);
      const rearranged = isoString.substring(8, 10) + '-' + isoString.substring(5, 7) + '-' + isoString.substring(0, 4) + ' ' + isoString.substring(11, 16);
      return rearranged;
    }
    return (
      <label className="">
        {formatDate(rowData.created_at)} <Langs str="by" />
        <br />
        {rowData.created_by ? `${rowData.created_by.nom} ${rowData.created_by.prenom}` : '-'}
      </label>
    )
  }

  const createdAtDateBodyTemplateSC = (rowData) => {
    if (!rowData.created_by && !rowData.nom_creator && !rowData.prenom_creator) {
      return null;
    }

    const formatDate = (timestamp) => {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      date.setHours(date.getHours() + 2);
      const isoString = date.toISOString().substring(0, 16);
      const rearranged = isoString.substring(8, 10) + '-' + isoString.substring(5, 7) + '-' + isoString.substring(0, 4) + ' ' + isoString.substring(11, 16);
      return rearranged;
    }

    return (
      <label className="">
        {formatDate(rowData.created_at)} <Langs str="by" />
        <br />
        {rowData.created_by ? `${rowData.nom_creator} ${rowData.prenom_creator}` : '-'}
      </label>
    )
  }

  const updatedAtDateBodyTemplateSC = (rowData) => {
    if (!rowData.updated_by && !rowData.nom_updater && !rowData.prenom_updater) {
      return null
    }
    const formatDate = (timestamp) => {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      date.setHours(date.getHours() + 2);
      const isoString = date.toISOString().substring(0, 16);
      const rearranged = isoString.substring(8, 10) + '-' + isoString.substring(5, 7) + '-' + isoString.substring(0, 4) + ' ' + isoString.substring(11, 16);
      return rearranged;
    }
    return (
      <label className="">
        {formatDate(rowData.updated_at)} <Langs str="by" />
        <br />
        {rowData.updated_by ? `${rowData.nom_updater} ${rowData.prenom_updater}` : '-'}
      </label>
    )
  }

  const updatedAtDateBodyTemplate = (rowData) => {
    if (!rowData.updated_by?.nom && !rowData.updated_by?.prenom) {
      return null
    }
    const formatDate = (timestamp) => {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      date.setHours(date.getHours() + 2);
      const isoString = date.toISOString().substring(0, 16);
      const rearranged = isoString.substring(8, 10) + '-' + isoString.substring(5, 7) + '-' + isoString.substring(0, 4) + ' ' + isoString.substring(11, 16);
      return rearranged;
    }
    return (
      <label className="">
        {formatDate(rowData.updated_at)} <Langs str="by" />
        <br />
        {rowData.created_by ? `${rowData.updated_by.nom} ${rowData.updated_by.prenom}` : '-'}
      </label>
    )
  }

  const commentsBodyTemplate = (rowData) => {
    const commentsArray = rowData.comments.split('\n');

    return (
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        {commentsArray.map((comment, index) => (
          comment.trim() !== "" && (
            <li key={index} style={{
              position: 'relative',
              paddingLeft: '20px',
              wordWrap: 'break-word',
              maxWidth: '35ch',
              marginBottom: '8px'
            }}>
              <span style={{
                position: 'absolute',
                left: '0',
                top: '0'
              }}>•</span>
              {comment}
            </li>
          )
        ))}
      </ul>
    )
  }

  const warningDateBodyTemplate = (rowData) => {
    if (rowData.warning_date) {
      return (<label className="">
        {rowData.warning_date ? getFormattedDate(rowData.warning_date) : '-'}
      </label>)
    } else if (rowData.start_date) {
      return (<label className="">
        {rowData.start_date ? getFormattedDate(rowData.start_date) : '-'}
      </label>)
    }
  }

  const categoryBodyTemplate = (rowData) => {
    let severity = getTagClass(rowData.category)
    return (
      <Tag value={<Langs str={rowData.category} />} severity={severity} />
    )
  }

  const specialCaseBodyTemplate = (rowData) => {
    let severity = getTagClass(rowData.case)
    return (
      <Tag value={<Langs str={rowData.case} />} severity={severity} />
    )
  }

  const warningStatusBodyTemplate = (rowData) => {
    return (
      <Tag severity={getTagClass(rowData.status)} value={capitalize(rowData.status)} />
    )
  }

  const viewCollabDetails = (rowData) => {
    return <Row className="d-flex justify-content-space-between align-items-center">
      <Col>
        {rowData.is_new ?
          <ImageButton
            image={fusion}
            imageFocus={fusionFocus}
            onClick={() => handleCollabFusion(rowData)}
            active={true}
            tooltip={<Langs str="Merge" />}
            width={32} />
          :
          rowData.current_id_team && <ImageButton
            image={userPlanning}
            imageFocus={userPlanningFocus}
            onClick={() => viewCollabPlanning(rowData)}
            active={true}
            tooltip={<Langs str="VIEW_PLANNING" />}
            width={32} />}
      </Col>
    </Row>
  }

  const viewWarningDetails = (rowData) => {
    const hasEditPermission = checkPermission(config.scopes.warnings, config.permissionTypes.edit);
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        {hasEditPermission && <ImageButton
          image={userInfo}
          imageFocus={userInfoFocus}
          onClick={() => viewWarningModal(rowData)}
          active={true}
          tooltip={<Langs str="VIEW_DETAILS" />}
          width={32}
        />}
        {hasEditPermission && (
          <ImageButton
            image={deleteIcon}
            imageFocus={deleteIconFocus}
            onClick={() => showConfirmDelete(rowData.id)}
            active={true}
            tooltip={<Langs str="DELETE_WARNING" />}
            width={32}
          />
        )}
      </div>
    )
  }
  const handicapBodyTemplate = (rowData) => {
    return (
      rowData.is_handicap === 1 ?
        <ImageButton
          image={handicapIcon}
          imageFocus={handicapIcon}
          onClick={() => { }}
          active={false}
          width={32}
        /> : "")

  }

  const viewSpecialCaseDetails = (rowData) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <ImageButton

          image={userInfo}
          imageFocus={userInfoFocus}
          onClick={() => viewSpecialCaseModal(rowData)}
          active={true}
          tooltip={<Langs str="VIEW_DETAILS" />}
          width={32}
        />
        {/* <ImageButton
          image={deleteIcon}
          imageFocus={deleteIconFocus}
          onClick={() => showConfirmDelete(rowData.id)}
          active={true}
          tooltip={<Langs str="DELETE_SPECIAL_CASE" />}
          width={32}
        /> */}
      </div>
    )
  }

  const showConfirmDelete = (id) => {
    setDeleteWarningId(id)
    setConfirmDeleteVisibility(true)
  }

  function toastRes() {
    if (permissionsMessage != null) {
      if (permissionsMessage.trim().toLowerCase().includes("successfully")) {
        showSuccessToast(permissionsMessage)
      } else {
        showErrorToast(permissionsMessage)
      }
      dispatch(setUpdatePermissionsRes())
    }
  }

  function viewCollabModal(data) {
    if (!checkPermission(config.scopes.collabs, config.permissionTypes.edit)) return;
    const modalData = { ...data, show: true };
    dispatch(setCollabModalData(modalData))
  }

  function viewCollabPlanning(data) {
    if (data.current_id_team) {
      dispatch(setSelectedTeams([data.current_id_team]))
      navigate(`/planning/${data.current_id_team}/MONTHLY${moment().startOf("month").format("DDMMYYYY")}`)
    }
  }

  function handleCollabFusion(data) {
    setMergeCollab(data)
  }

  function viewWarningModal(data) {
    dispatch(setWarningData(data));
    dispatch(setWarningDetailsDialog(true))
  }

  function viewSpecialCaseModal(data) {
    dispatch(setSpecialCaseModalData(data));
    dispatch(setDisplaySpecialCaseModalDetails(true));
  }

  const HandleAddWarningModal = () => {
    dispatch(setAddWarningDialog(true))
  }

  const handleEndOfMerge = (collab) => {
    if (collab) viewCollabModal(collab)
    dispatch(getAllCollabs())
  }

  let companies = [], statuses = [], collabsTypes = [], silaeStatuses = []
  listCollabs().map(collab => {
    if (collab.company && !companies.includes(collab.company))
      companies.push(collab.company)
    if (collab.statut && !statuses.includes(collab.statut))
      statuses.push(collab.statut)
    if (collab.type_collab && !collabsTypes.includes(collab.type_collab))
      collabsTypes.push(collab.type_collab)
    if (collab.silaeStatus && !silaeStatuses.includes(collab.silaeStatus))
      silaeStatuses.push(collab.silaeStatus)
  })

  let warningStatuses = [], warningCategories = []
  allWarningsList.map(warning => {
    if (warning.status && !warningStatuses.includes(warning.status))
      warningStatuses.push(warning.status)
    if (warning.category && !warningCategories.includes(warning.category))
      warningCategories.push(warning.category)
  })

  let specialCasesCategories = []
  specialCases.map(specialCase => {
    if (specialCase.case && !specialCasesCategories.includes(specialCase.case))
      specialCasesCategories.push(specialCase.case)
  })

  const statusItemTemplate = (option) => {
    if (option)
      return <Tag value={<Langs str={option} />} severity={getTagClass(option)} />
    return <div><Langs str={'Select'} /></div>
  }

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={statuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const silaeStatusdRowFilterTemplate = (options) => {
    return (
      <MultiSelect value={options.value}
        options={silaeStatuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={silaeStatusBodyTemplate}
        valueTemplate={silaeStatusBodyTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )

  }

  const silaeStatusFilterFunction = (value, filters) => {
    if (!filters || filters.length === 0) return true;
    return filters.includes(value);
  };

  const warningsStatusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={warningStatuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const warningsCategoryRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={warningCategories}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const specialCasesRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={specialCasesCategories}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const collabsTypeRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={collabsTypes}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const companiesItemTemplate = (option) => {
    if (option)
      return (
        <div className="flex align-items-center gap-2">
          <span>{option}</span>
        </div>
      )
    return <div><Langs str={'Select'} /></div>
  }

  const companyRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={companies}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={companiesItemTemplate}
        valueTemplate={companiesItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const contractTypeRowFilterTemplate = (options) => {
    let typeOfContractStrings = [
      'CDI',
      'Indépendant',
      'Portage',
      'Contrat d\'apprentissage',
      'Sous traitant',
      'Intérimaire',
      'CDD',
      'Agence',
      'Convention de stage'
    ]
    return (
      <MultiSelect
        value={options.value || []}
        options={typeOfContractStrings}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={<Langs str={"Select One"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }
  const contractTypeFilterFunction = (value, filters) => {
    if (!filters || filters.length === 0) return true;
    return filters.includes(value);
  };

  const motifSortieRowFilterTemplate = (options) => {
    let typesOfMotifSortie = [
      "Démission",
      "Licenciement",
      "Rupture conventionnelle",
      "Rupture anticipée du contrat",
      "Fin de CDD",
      "Rupture de période d’essai employeur",
      "Rupture de période d’essai salarié",
      "Retraite",
      "Décès",
      "Invalidité"
    ];
    return (
      <MultiSelect
        value={options.value || []}
        options={typesOfMotifSortie}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={<Langs str={"Select One"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }
  const motifSortieFilterFunction = (value, filters) => {
    if (!filters || filters.length === 0) return true;
    return filters.includes(value);
  };

  const dateFilterTemplate = (options) => {
    return <Calendar value={options.value}
      onChange={(e) => options.filterCallback(e.value, options.index)}
      dateFormat="dd/mm/yy"
      placeholder="dd/mm/yyyy"
      mask="99/99/9999" />
  }

  const typeCollabBodyTemplate = (rowData) => {
    return <Tag severity={getTagClass(rowData.type_collab)} value={Localize(rowData.type_collab)} />
  }

  const silaeStatusBodyTemplate = (silaeStatus) => {
    let background = "grey"
    let color = "white"
    let border = "none"
    switch (silaeStatus) {
      case "Closed":
        background = "red"
        break
      case "Non-Closed":
        background = "slateBlue"
        break
      case "Ongoing":
        background = "white"
        color = "black"
        border = "1px solid black"
        break
      default:
        break
    }
    return <Tag style={{ background, color, border }} value={Localize(silaeStatus)} />
  }

  const navToTeam = (rowData) => {
    const encodedLabel = encodeURIComponent(rowData.current_team_name);
    navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`);
    //setSelectedTeams([rowData.id_team])
  }

  const teamBodyTemplate = (rowData) => {
    return (
      <a className={styles.linkStyle} onClick={() => navToTeam(rowData)}>{rowData.current_team_name}</a>
    )
  }

  const handleViewChange = (view) => {
    if (view != null) {
      let selectedTeamId = selectedTeamsIds[0]
      navigate(`/collabs/${selectedTeamId}/${view}`)
    }
  }

  function deleteWarningFinal() {
    dispatch(deleteWarning(deleteWarningId));
    setDeleteWarningId(null);
    setConfirmDeleteVisibility(false);
  }

  function renderConfirmDelete() {
    return (
      <div className="card flex justify-content-center">
        <Dialog header={<Langs str="DELETE" />}
          draggable={false}
          visible={confirmDeleteVisibility}
          style={isMobile == 1 ? { width: '25vw' } : { width: '100vw' }}
          onHide={() => { setConfirmDeleteVisibility(false); setDeleteWarningId(null) }}>
          <label className="mb-3 text-center w-100">
            <Langs str="CONFIRM_DELETE" />
          </label>
          <div className="w-50 mx-auto">

            <DynamicButton
              onClick={() => deleteWarningFinal()}
              title={<Langs str="DELETE_WARNING" />}
              active={true}
              color="red"
            />
          </div>
        </Dialog>
      </div>
    )
  }

  function renderBody() {
    let scrollHeight = "calc(100vh - 280px)"
    switch (isMobile) {
      case 2:
        scrollHeight = "calc(100vh - 340px)"
        break;
      case 3:
        scrollHeight = "calc(100vh - 270px)"
        break;
      default:
        break;
    }

    let date = moment().format("DD-MM-YYYY")
    let subView = viewsOptions[selectedView]
    if (subView) {
      switch (subView.value) {
        case 0:
          return <div className={styles.collabsCard}>
            <DataTable ref={dtCollabs}
              onValueChange={(data) => setFilteredCollabs(data)}
              exportFilename={`Collabs_export_${date}`}
              value={listCollabs()}
              dataKey="id"
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rowsPerPageOptions={[10, 25, 50]}
              rows={25}
              scrollable
              scrollHeight={scrollHeight}
              sortMode="single"
              filters={collabsFilters}
              currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
              onRowDoubleClick={(e) => viewCollabModal(e.data)}
              selectionMode="single"
              header={collabsTableHeader}
            >
              {listCollabs().length <= 1 && <Column style={{ width: '3rem' }} />}
              <Column field="matricule" header={Localize("Matricule")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="company" header={Localize("Company")} sortable style={{ minWidth: '8rem' }} filterField="company" showFilterMatchModes={false} filter filterElement={companyRowFilterTemplate}></Column>
              <Column field="type_collab" header={Localize("Type")} body={typeCollabBodyTemplate} sortable style={{ minWidth: '8rem' }} showFilterMatchModes={false} filter filterElement={collabsTypeRowFilterTemplate}></Column>
              <Column field="title" filter filterPlaceholder="Civilité" header={Localize("Civilité")} sortable dataType="text" style={{ minWidth: '9rem' }}></Column>
              <Column field="nom" filter filterPlaceholder="nom" header={Localize("Family Name")} sortable dataType="text" style={{ minWidth: '9rem' }}></Column>
              <Column field="prenom" filter filterPlaceholder="prenom" header={Localize("Name")} sortable style={{ minWidth: '9rem' }}></Column>
              <Column field="statut" header={Localize("Status")} sortable body={statusBodyTemplate} style={{ minWidth: '7rem' }} showFilterMatchModes={false} filter filterElement={statusRowFilterTemplate}></Column>
              <Column field="silaeStatus" header={Localize("Silae Status")} sortable body={(data) => silaeStatusBodyTemplate(data.silaeStatus)} style={{ minWidth: '8rem' }} showFilterMatchModes={false} filter filterElement={silaeStatusdRowFilterTemplate} filterFunction={silaeStatusFilterFunction}></Column>
              <Column field="current_team_name" header={Localize("Team")} body={teamBodyTemplate} filter sortable style={{ minWidth: '9rem' }}></Column>
              <Column field="last_team_name" header={Localize("Équipe précédente")} filter sortable style={{ minWidth: '9rem' }}></Column>
              <Column field="mobileNumber" header={Localize("Mobile")} filter style={{ minWidth: '10rem' }}></Column>
              <Column field="type_contrat" header={Localize("CONTRACT_TYPE")} showFilterMatchModes={false} filter filterFunction={contractTypeFilterFunction} filterElement={contractTypeRowFilterTemplate} sortable style={{ minWidth: '10rem' }}></Column>
              <Column field="email" header={Localize("Email")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="security_number" header={Localize("Security Number")} sortable filter style={{ minWidth: '10rem' }}></Column>
              <Column field="current_poste" header={Localize("Poste")} filter sortable style={{ minWidth: '12rem' }}></Column>
              <Column field="nature_emploi" header={Localize("Nature emploi")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="statut_emploi" header={Localize("Statut emploi")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="coefficient" header={Localize("Coefficient")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="position" header={Localize("Position")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="etablissement" header={Localize("Etablissement de rattachement")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="first_experience_date" header={Localize("Date de 1ère expérience")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="ancienneteeDate" header={Localize("Anciennetee Date")} sortable body={dateBodyTemplate} filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="entryDate" header={Localize("Date de début du contrat en cours")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="periodeEssai1" header={Localize("Première période d'éssai")} sortable body={colorDateBodyTemplate} filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="periodeEssai2" header={Localize("Deuxième période d'éssai")} sortable body={colorDateBodyTemplate} filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="exitDate" header={Localize("Date de fin de du contrat en cours")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="last_contract_sortie_date" header={Localize("Date de la sortie effective")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="motif_sortie" header={Localize("Motif de la sortie effective")} sortable style={{ minWidth: '10rem' }} filter showFilterMatchModes={false} filterElement={motifSortieRowFilterTemplate} filterFunction={motifSortieFilterFunction}></Column>
              <Column field="solde_cp_old_remaining" header={Localize("CPN-1 SILAE")} sortable style={{ minWidth: '10rem' }}></Column>
              <Column field="solde_cp_current_remaining" header={Localize("CPN SILAE")} sortable style={{ minWidth: '10rem' }}></Column>
              <Column field="solde_cp_old" header={Localize("CPN-1")} sortable body={soldeOldBodyTemplate} style={{ minWidth: '10rem' }}></Column>
              <Column field="solde_cp_old_expiry" header={Localize("Expiration CPN-1")} sortable body={soldeExpirylBodyTemplate} style={{ minWidth: '10rem' }}></Column>
              <Column field="solde_cp_current" header={Localize("CPN")} sortable body={soldeCurrentBodyTemplate} style={{ minWidth: '10rem' }}></Column>
              <Column field="frais_tel" header={Localize("Frais téléphonique")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="forfait_deplacement" header={Localize("Forfait déplacement")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="date_debut_cp" header={Localize("date_debut_cp")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="date_fin_cp" header={Localize("date_fin_cp")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="new_date_fin_cp" header={Localize("new_date_fin_cp")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="tjm_achat" header={Localize("tjm_achat")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="tjm_vente" header={Localize("tjm_vente")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="subcontractor" header={Localize("Subcontractor")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="subcontractor_email" header={Localize("Subcontractor Email")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="createdAt" header={Localize("created_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: '8rem' }}></Column>
              <Column field="handiCapIcon" body={handicapBodyTemplate} style={{ minWidth: '6rem', textAlign: 'right' }} exportable={false}></Column>
              <Column field="viewCollabDetailsBtn" body={viewCollabDetails} style={{ minWidth: '6rem' }} alignFrozen="right" frozen={true} exportable={false}></Column>
            </DataTable>
          </div>
        case 1:
          return <div className={styles.collabsCard}>
            <DataTable ref={dtWarnings}
              value={allWarningsList}
              exportFilename={`Suivis_export_${date}`}
              dataKey="id"
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rowsPerPageOptions={[10, 25, 50]}
              rows={25}
              scrollable
              scrollHeight={scrollHeight}
              sortMode="single"
              filters={warningsFilters}
              currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
              header={warningsTableHeader}
            >
              {allWarningsList.length <= 1 && <Column style={{ width: '3rem' }} />}
              <Column field="id" header={Localize("ID")} filter sortable style={{ minWidth: '7rem' }}></Column>
              <Column field="collab_matricule" header={Localize("Matricule")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="collab_nom" header={Localize("Family Name")} filter sortable dataType="text" style={{ minWidth: '8rem' }}></Column>
              <Column field="collab_prenom" header={Localize("Name")} filter sortable style={{ minWidth: '9rem' }}></Column>
              <Column field="category" header={Localize("category")} filter filterElement={warningsCategoryRowFilterTemplate} showFilterMatchModes={false} sortable body={categoryBodyTemplate} style={{ minWidth: '11rem' }}></Column>
              <Column field="status" header={Localize("statut")} filter filterElement={warningsStatusRowFilterTemplate} showFilterMatchModes={false} sortable body={warningStatusBodyTemplate} style={{ minWidth: '9rem' }}></Column>
              <Column field="team_name" header={Localize("Client")} filter sortable style={{ minWidth: '9rem' }}></Column>
              <Column field="warning_date" header={Localize("Date")} filter filterElement={dateFilterTemplate} dataType="date" sortable body={warningDateBodyTemplate} style={{ minWidth: '9rem' }}></Column>
              <Column field="created_at" header={Localize("created_at")} filter filterElement={dateFilterTemplate} dataType="date" sortable body={createdAtDateBodyTemplate} style={{ minWidth: '9rem' }}></Column>
              <Column field="updated_at" header={Localize("updated_at")} filter filterElement={dateFilterTemplate} dataType="date" sortable body={updatedAtDateBodyTemplate} style={{ minWidth: '9rem' }}></Column>
              <Column field="comments" header={Localize("DESCRIPTION")} body={commentsBodyTemplate} style={{ minWidth: '9rem' }}></Column>
              <Column field="viewCollabDetailsBtn" body={viewWarningDetails} style={{ minWidth: '6rem', textAlign: 'right' }} alignFrozen="right" frozen={true} exportable={false}></Column>
            </DataTable>
          </div>
        case 2:
          return (
            <div className={styles.collabsCard}>
              <DataTable ref={dtSpecialCases}
                value={specialCases}
                exportFilename={`Cas_particuliers_export_${date}`}
                dataKey="id"
                paginator
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[10, 25, 50]}
                rows={25}
                scrollable
                scrollHeight={scrollHeight}
                sortMode="single"
                filters={specialCasesFilters}
                currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                header={specialCasesTableHeader}
              >
                {specialCases && specialCases.length <= 1 && <Column style={{ width: '3rem' }} />}
                <Column field="id" header={Localize("ID")} sortable dataType="text" style={{ minWidth: '8rem' }} />
                <Column field="nom_collab" header={Localize("Family Name")} filter sortable dataType="text" style={{ minWidth: '8rem' }} />
                <Column field="prenom_collab" header={Localize("Name")} filter sortable style={{ minWidth: '9rem' }} />
                <Column field="case" header={Localize("category")} filter filterElement={specialCasesRowFilterTemplate} showFilterMatchModes={false} sortable body={specialCaseBodyTemplate} style={{ minWidth: '11rem' }} />
                <Column field="team_name" header={Localize("Client")} filter sortable style={{ minWidth: '10rem' }} />
                <Column field="startDate" header={Localize("START_DATE")} filter filterElement={dateFilterTemplate} dataType="date" sortable body={dateBodyTemplate} style={{ minWidth: '10rem' }} />
                <Column field="endDate" header={Localize("END_DATE")} filter filterElement={dateFilterTemplate} dataType="date" sortable body={dateBodyTemplate} style={{ minWidth: '10rem' }} />
                <Column field="created_at" header={Localize("created_at")} sortable body={createdAtDateBodyTemplateSC} style={{ minWidth: '9rem' }} />
                <Column field="updated_at" header={Localize("updated_at")} sortable body={updatedAtDateBodyTemplateSC} style={{ minWidth: '9rem' }} />
                <Column field="comments" header={Localize("Comments")} filter sortable style={{ minWidth: '10rem' }} />
                <Column field="viewCollabDetailsBtn" body={viewSpecialCaseDetails} style={{ minWidth: '6rem', textAlign: 'right' }} alignFrozen="right" frozen={true} exportable={false}></Column>
              </DataTable>
            </div>
          )
        case 3:
          return <EmploymentPromisesView />

        default:
          break
      }
    }
  }

  function topMenu() {
    if (isMobile == 1) {
      return (
        <Row>
          <Col md={3}>
            <span className="headerTitle">
              {viewsOptions.find(o => o.value == selectedView)?.label}
            </span>
          </Col>
          <Col md={6}
            className="d-flex justify-content-center pe-4 align-items-center p-0 m-0">
            {
              checkPermission(config.scopes.warnings, config.permissionTypes.view) &&
              checkPermission(config.scopes.collabs, config.permissionTypes.view) &&
              (
                <ViewSelectButton
                  options={viewsOptions}
                  selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
                  onViewChange={handleViewChange}
                />
              )
            }
          </Col>
          <Col md={3}
            className="d-flex justify-content-end pe-4 align-items-center p-0 m-0 ms-auto">
            {selectedView != 3 && <ImageButton
              image={exportIcon}
              imageFocus={exportIconFocus}
              onClick={exportFilteredData}
              active={true}
              tooltip="Export collabs"
              width={32} />}
            {selectedView == 0 && (
              <div>
                {/*<ImageButton
                  image={exportIcon}
                  imageFocus={exportIconFocus}
                  onClick={exportExcelContracts}
                  active={true}
                  tooltip={<Langs str="Export contrats" />}
                  width={32} />*/}
                <ImageButton
                  image={addIcon}
                  imageFocus={addIconFocus}
                  onClick={() => setDisplayAddExterneModal(true)}
                  active={true}
                  tooltip={<Langs str="ADD_EXTERNE" />}
                  width={32} />
              </div>
            )}
            {checkPermission(config.scopes.warnings, config.permissionTypes.edit) && selectedView == 1 && (
              <ImageButton
                image={addIcon}
                imageFocus={addIconFocus}
                onClick={HandleAddWarningModal}
                active={true}
                tooltip={<Langs str="ADD_WARNING" />}
                width={32} />
            )}
            {selectedView == 2 && (
              <ImageButton
                image={addIcon}
                imageFocus={addIconFocus}
                onClick={() => setDisplaySpecialCaseModal(true)}
                active={true}
                tooltip={<Langs str="ADD" />}
                width={32} />
            )}
          </Col>
        </Row>
      )
    }
    if (isMobile == 2 || isMobile == 3) {
      return (
        <Row>
          <Col md={5}>
            <span className="headerTitle">
              {viewsOptions.find(o => o.value == selectedView)?.label}
            </span>
          </Col>
          <Col md={7}
            className="d-flex justify-content-between align-items-center m-0 mt-3">
            {
              checkPermission(config.scopes.warnings, config.permissionTypes.view) &&
              checkPermission(config.scopes.collabs, config.permissionTypes.view) &&
              (
                <ViewSelectButton
                  options={viewsOptions}
                  selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
                  onViewChange={handleViewChange}
                />
              )
            }
            <div>
              <ImageButton
                image={exportIcon}
                imageFocus={exportIconFocus}
                onClick={exportFilteredData}
                active={true}
                tooltip="Export"
                width={32} />
              {checkPermission(config.scopes.warnings, config.permissionTypes.edit) && selectedView == 1 && (
                <ImageButton
                  image={addIcon}
                  imageFocus={addIconFocus}
                  onClick={HandleAddWarningModal}
                  active={true}
                  tooltip={<Langs str="ADD_WARNING" />}
                  width={32} />
              )}
            </div>
          </Col>
        </Row>
      )
    }
  }

  return (
    <div className={styles.containerView}>
      <div className="topMenu">
        {topMenu()}
      </div>
      {renderBody()}
      {renderConfirmDelete()}
      <CollabModalDetails
        page="collabs"
        tabs={["contrat", "societe", "mission", "donneesPerso", "profil"]}
      />
      <ResetPasswordDialog />
      <PermissionsModal page="collabs" />
      <WarningDetailsDialog />
      <AddExterneModal
        visible={displayAddExterneModal}
        onHide={() => setDisplayAddExterneModal(false)}
      />
      <AddWarning />
      <MergeCollabModal visible={mergeCollab}
        originalCollab={mergeCollab}
        onMergeDone={(collab) => handleEndOfMerge(collab)}
        onHide={() => setMergeCollab(null)} />
      <AddSpecialCaseModal
        visible={displaySpecialCaseModal}
        onHide={() => setDisplaySpecialCaseModal(false)}
      />
      <SpecialCaseDetailsDialog />
    </div>
  )
}